import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import OidcService from 'services/OidcService';
async function action({ route }) {
    if (process.env.BROWSER) {
        await OidcService.loginSilentCallback();
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        component: /*#__PURE__*/ _jsx("div", {})
    };
}
export default action;
